import { withLocalState } from 'pyradux';

import LedgerContainer from './Ledger.container';
import reducer from './Ledger.reducer';
import LedgerSagas from './Ledger.sagas';

const withLocalStateOptions = {
  reducer,
  stateKey: 'ledger',
  sagas: [LedgerSagas],
};

export default withLocalState(withLocalStateOptions, LedgerContainer);



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Ledger/index.js